import React from 'react'
import Routes from './Routes'

export default () => (
    <div className='height100'>
        <div className='height100'>
            <Routes />
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js